import {
  CustomTabList
} from "@/components";
import { Tabs, TabsContent } from "@radix-ui/react-tabs";
import { tabs } from "./consts";
import CurriculumMgmtInfo from "./CurriculumManagement/CurriculumMgmtInfo";
import ResourceManagementInfo from "./ResourceManagement/ResourceManagementInfo";
import TaskAssignment from "./TaskManagement/TaskAssignment";
import { MyTasks } from "@/pages/Admin";
import useCrmMgmtInfo from "./useCrmMgmtInfo";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";
import { LOGIN_ROLES } from "@/lib/utils";
import { useMemo } from "react";

const CrmMgmtInfo = () => {
  const { currentTab, action, onTabChange } = useCrmMgmtInfo();
  const loggedInUserData = useSelector(
    (state: RootState) => state.currentData.loggedInUserData
  );

  // Backend sends role as array, e.g. ["CRM_HEAD"]
  const roles = loggedInUserData?.role || [];
  const hasRole = (role: string) =>
    Array.isArray(roles) && roles.includes(role);

  const filteredTabs = useMemo(() => {
    if (hasRole("RELATIONSHIP_MANAGER")) {
      return tabs?.filter(tab => tab.value !== "2");
    }

    return tabs;
  }, [tabs]);



  return (
    <div className="bg-white">
      <Tabs
        defaultValue="1"
        className="m-2"
        value={currentTab}
        onValueChange={onTabChange}
      >
        <CustomTabList
          tabs={filteredTabs}
          className="mx-5"
          currentTab={currentTab}
          action={action}
        />

        {/* Tab 1 */}
        <TabsContent value="1" className="px-0">
          <ResourceManagementInfo />
        </TabsContent>

        {/* Tab 2 → Conditional */}
        <TabsContent value="2" className="px-0 mt-20">
          <div
            style={{
              display:
                hasRole(LOGIN_ROLES.CRM_HEAD) ||
                hasRole(LOGIN_ROLES.SALES_OPS) ||
                hasRole(LOGIN_ROLES.SUPER_ADMIN)
                  ? "block"
                  : "none",
            }}
          >
            <TaskAssignment />
          </div>
          <div
            style={{
              display: !(
                hasRole(LOGIN_ROLES.CRM_HEAD) ||
                hasRole(LOGIN_ROLES.SALES_OPS) ||
                hasRole(LOGIN_ROLES.SUPER_ADMIN)
              )
                ? "block"
                : "none",
            }}
          >
            <MyTasks />
          </div>
        </TabsContent>

        {/* Tab 3 */}
        <TabsContent value="3" className="px-0">
          <CurriculumMgmtInfo />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default CrmMgmtInfo;
